import { render, staticRenderFns } from "./DataCollectionDetails.vue?vue&type=template&id=f8884cc4&scoped=true&"
import script from "./DataCollectionDetails.vue?vue&type=script&lang=js&"
export * from "./DataCollectionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8884cc4",
  null
  
)

export default component.exports